import $ from 'jquery';
import collapse from 'bootstrap';
import A11yUtils from '@core/base/scripts/utils/a11y-utils.js';
import whatInput from 'what-input';


export default class BaseAccordion {
  constructor() {
    this.$collapses = null;
    this.container = null;
    this.module = null;
  }

  init() {
    this.$collapses = $('.collapse');
    this.$collapseBtns = $('.base-accordion__button');


    this.$collapseBtns.off().on('click', function () {

      const $btn = $(this);
      const target = $btn.attr('aria-controls');
      const $collapse = $(`#${target}`);

      $collapse.collapse('toggle');
    });

    this.$collapses.on('show.bs.collapse', function () {
      const $collapse = $(this);
      const $focusables = $collapse.find(A11yUtils.FOCUSABLES);
      if ($focusables.length > 0 && whatInput.ask() === 'keyboard') {
        setTimeout(() => {
          $focusables[0].focus();
        }, 0);

      }
      setBtnProps($(this), false);
    });

    this.$collapses.on('hide.bs.collapse', function () {
      setBtnProps($(this), true);
    });

    function setBtnProps($collapse, collapsed) {
      const id = $collapse.attr('id');
      const $btn = $(`[aria-controls=${id}]`);
      $btn.attr('aria-expanded', !collapsed).toggleClass('collapsed', collapsed);
    }
  }
}
